<template>
  <div>
    <v-divider />
    <v-card-actions>
      <slot />
    </v-card-actions>
  </div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "CardFooter",
  props: ["title", "color"],
  data() {
    return {};
  },
});
</script>
